import { take, call, put } from 'redux-saga/effects';
import * as types from '../../../lib/actionTypes.es6';
import * as actions from './actions';
import {
  getOrgProductTemplates,
  createOrgProductTemplate,
  updateOrgProductTemplate,
  deleteOrgProductTemplate,
} from '../../../lib/requests.es6';
import { GAloggerException } from '../../../lib/monitoring.es6';
import { unAuthorizedNotification } from '../../../lib/access.es6';

function extractError(e) {
  if (e.response && e.response.data) { return e.response.data; }
  return 'An unexpected error occurred';
}

export function* getOrgProductTemplatesRequestWatcher() {
  for (;;) {
    var request = yield take(types.GET_ORG_PRODUCT_TEMPLATES_REQUEST);
    try {
      var response = yield call(getOrgProductTemplates, request.payload);
      yield put(actions.getOrgProductTemplatesSuccess(response.data));
    } catch (e) {
      yield put(actions.getOrgProductTemplatesFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* createOrgProductTemplateRequestWatcher() {
  for (;;) {
    var request = yield take(types.CREATE_ORG_PRODUCT_TEMPLATE_REQUEST);
    try {
      var response = yield call(createOrgProductTemplate, request.payload);
      yield put(actions.createOrgProductTemplateSuccess(response.data));
    } catch (e) {
      yield put(actions.createOrgProductTemplateFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* updateOrgProductTemplateRequestWatcher() {
  for (;;) {
    var request = yield take(types.UPDATE_ORG_PRODUCT_TEMPLATE_REQUEST);
    try {
      var response = yield call(
        updateOrgProductTemplate,
        request.payload.guid,
        request.payload
      );
      yield put(actions.updateOrgProductTemplateSuccess(response.data));
    } catch (e) {
      yield put(actions.updateOrgProductTemplateFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* deleteOrgProductTemplateRequestWatcher() {
  for (;;) {
    var request = yield take(types.DELETE_ORG_PRODUCT_TEMPLATE_REQUEST);
    try {
      yield call(
        deleteOrgProductTemplate,
        request.payload.guid,
        request.payload.organizationGuid
      );
      yield put(actions.deleteOrgProductTemplateSuccess(request.payload.guid));
    } catch (e) {
      yield put(actions.deleteOrgProductTemplateFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}
